import { $t } from '@/plugins/fluent';
import { markRaw } from 'vue';
import GroupedEntriesIcon from '../Icon/GroupedEntriesIcon.vue';
import NestedEntriesIcon from '../Icon/NestedEntriesIcon.vue';
import { OptionSwitchEntryType } from '../OptionSwitch/types';

export const DEFAULT_OPTION_SWITCH_ID = 'sections';

export const timelineOptionSwitchEntries: OptionSwitchEntryType[] = [
    {
        index: 0,
        id: DEFAULT_OPTION_SWITCH_ID,
        label: $t('timeline-locations-display-sections-label'),
        icon: markRaw(GroupedEntriesIcon),
    },
    {
        index: 1,
        id: 'hierarchy',
        label: $t('timeline-locations-display-hierarchy-label'),
        icon: markRaw(NestedEntriesIcon),
    },
];
